/**
 * @module nwp/NwpSource
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Source from 'ol/source/Source.js';
import SourceState from 'ol/source/State.js';
var NwpSource = /** @class */ (function (_super) {
    __extends(NwpSource, _super);
    /**
     * @param {Options=} opt_options Vector source options.
     */
    function NwpSource(opt_options) {
        var _this = this;
        var options = opt_options || {};
        _this = _super.call(this, {
            attributions: options.attributions,
            projection: undefined,
            state: SourceState.UNDEFINED,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
        }) || this;
        /**
         * @private
         * @type {import("../featureloader.js").FeatureLoader}
         */
        _this.loader_ = function VOID() { };
        /**
         * @private
         * @type {boolean}
         */
        _this.overlaps_ = options.overlaps === undefined ? true : options.overlaps;
        _this.url_ = options.url;
        _this.type_ = options.type;
        _this.scale_ = options.scale === undefined ? 10.0 : options.scale;
        /**
         * @private
         * @type {string|import("../featureloader.js").FeatureUrlFunction|undefined}
         */
        _this.deflautLoader = function loader_(success, failure) {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', this.url_, true);
            xhr.responseType = 'arraybuffer';
            xhr.withCredentials = false;
            /**
             * @param {Event} event Event.
             * @private
             */
            xhr.onload = function (event) {
                // status will be 0 for file:// urls
                if (!xhr.status || (xhr.status >= 200 && xhr.status < 300)) {
                    var source = /** @type {ArrayBuffer} */ (xhr.response);
                    if (source) {
                        success(source);
                    }
                    else {
                        failure();
                    }
                }
                else {
                    failure();
                }
            };
            xhr.onerror = failure;
            xhr.send();
        }.bind(_this);
        _this.deflautSuccess = function (source) {
            this.source_ = source;
            this.setState(SourceState.READY);
        }.bind(_this);
        _this.deflautFailure = function () {
            this.setState(SourceState.ERROR);
            console.log("error " + this.url_);
        }.bind(_this);
        if (options.loader !== undefined) {
            _this.loader_ = options.loader;
        }
        else if (_this.url_ !== undefined) {
            // create a XHR feature loader for "url" and "format"
            _this.loader_ = _this.deflautLoader;
        }
        _this.source_ = null;
        _this.loadNwpData();
        return _this;
    }
    NwpSource.prototype.loadNwpData = function () {
        var state = this.getState();
        if (state != SourceState.READY && state != SourceState.LOADING) {
            this.setState(SourceState.LOADING);
            this.loader_(this.deflautSuccess, this.deflautFailure);
        }
        else if (state == SourceState.READY) {
            var data = [];
            var view = new DataView(this.source_);
            var dataIndex = 0;
            var byteLength = this.source_.byteLength;
            switch (this.type_) {
                case 'INT16':
                    while (dataIndex < byteLength) {
                        var v = view.getInt16(dataIndex);
                        data.push(v / this.scale_);
                        dataIndex += 2;
                    }
                    break;
                case 'INT8':
                    while (dataIndex < byteLength) {
                        var v = view.getInt8(dataIndex);
                        data.push(v);
                        dataIndex++;
                    }
                    break;
            }
            return data;
        }
    };
    /**
     * Get the url associated with this source.
     *
     * @return {string|import("../featureloader.js").FeatureUrlFunction|undefined} The url.
     * @api
     */
    NwpSource.prototype.getUrl = function () {
        return this.url_;
    };
    NwpSource.prototype.refresh = function () {
        this.clear(true);
        _super.prototype.refresh.call(this);
    };
    /**
     * Set the new loader of the source. The next render cycle will use the
     * new loader.
     * @param {import("../featureloader.js").FeatureLoader} loader The loader to set.
     * @api
     */
    NwpSource.prototype.setLoader = function (loader) {
        this.loader_ = loader;
    };
    /**
     * Points the source to a new url. The next render cycle will use the new url.
     * @param {string|import("../featureloader.js").FeatureUrlFunction} url Url.
     * @api
     */
    NwpSource.prototype.setUrl = function (url) {
        this.url_ = url;
        this.setState(SourceState.UNDEFINED);
        this.loader_(this.deflautSuccess, this.deflautFailure);
    };
    return NwpSource;
}(Source));
export default NwpSource;
//# sourceMappingURL=NwpSource.js.map